import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import { RegistrationDetailsFormDataCloudAccount } from '@/common/viewModels/registrationDetails/form/data/RegistrationDetailsFormDataCloudAccount';
import { RegistrationsDetailsFormStateCloudAccount } from '@/common/viewModels/registrationDetails/form/state/RegistrationDetailsFormStateCloudAccount';
import { OnboardingRegistrationOdinAccount, OnboardingRegistration } from '@/common/models';
import { ItemViewModel, RegistrationDetailsOdinRefresh } from '@/common/viewModels';
import { Button } from '@/external/telstra-ui-vue/components';
@Component({
  components: {
    Button,
  },
})
export default class RegistrationDetailsEditCloudAccount extends Vue {
  @Prop({ required: true }) data!: RegistrationDetailsFormDataCloudAccount;
  @Prop({ required: true }) state!: RegistrationsDetailsFormStateCloudAccount;
  @Prop({ required: true }) onboardingRegistrationOdinAccounts!: OnboardingRegistrationOdinAccount[];
  @Prop({ required: true }) odinDataRefresh!: RegistrationDetailsOdinRefresh;
  @Prop({ required: true }) onboardingRegistration!: OnboardingRegistration;
  @Prop() testing!: boolean;

  get accountOptions(): ItemViewModel[] {
    return this.onboardingRegistrationOdinAccounts.map((account) => new ItemViewModel(account.accountId, account.accountId));
  }

  get hasSingleAccount(): boolean {
    return this.onboardingRegistrationOdinAccounts.length === 1;
  }

  mounted(): void {
    this._initialiseVForm();
  }

  @Emit()
  formInputChange(inputEvent: any) {
    const target: any = inputEvent.target;
    this.$emit('formInputChange', target.name, target.value);
  }

  @Emit()
  getOdinDataClicked() {
    if (!this.odinDataRefresh.isDisabled) {
      this.$emit('getOdinDataClicked');
    }
  }

  private _initialiseVForm() {
    if (this.testing !== true) {
      (this.$refs.vForm as any).validate();
    }
  }

}
